import React from "react";
import getOr from "lodash/fp/getOr";
import tabStructure from "./tab-structure";
import { TabContainer, SumBookings, Tab } from "./member-shift-list.styles";

const TabNavigation = ({
  activeTab,
  itemsCount,
  totalBookings,
  memberId,
  onTabChange
}) => {
  return (
    <TabContainer>
      <SumBookings>All Bookings {totalBookings}</SumBookings>
      {tabStructure.map((tab, key) => (
        <Tab
          isActive={tab.keyProp === activeTab}
          key={key}
          onClick={() => {
            onTabChange({
              memberId,
              bookingState: tab.bookingState,
              bookingStates: tab.bookingStates,
              activeTab: tab.keyProp,
              ...tab.queryConditions
            });
          }}
        >
          {tab.title} {getOr(0, tab.keyProp, itemsCount)}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default TabNavigation;
